var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { md: "6", sm: "12" } },
                    [
                      _vm.currencies
                        ? _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("currencies"))),
                              ]),
                              _vm._l(_vm.currencies, function (currency, i) {
                                return _c(
                                  "w-list-item",
                                  { key: i },
                                  [
                                    _c("w-list-item-text", [
                                      _vm._v(_vm._s(currency.Name)),
                                    ]),
                                    _c("w-list-item-text", [
                                      _vm._v(_vm._s(currency.Rate)),
                                    ]),
                                    _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct("common.edit"),
                                                expression:
                                                  "$ct('common.edit')",
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.editCurrency(
                                                  currency.ID
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "pen" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _c("w-card-actions", [_c("w-spacer")], 1),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showCurrencyModal,
            callback: function ($$v) {
              _vm.showCurrencyModal = $$v
            },
            expression: "showCurrencyModal",
          },
        },
        [
          _c("app-currency-edit", {
            attrs: { currency: _vm.toEditCurrency },
            on: {
              close: function ($event) {
                _vm.showCurrencyModal = false
              },
              update: _vm.fetch,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }